export default "__VITE_ASSET__CuVA9uRn__"